(function () {
  const CONFIG = {
    shopDomain: window.shopDomain,
    apiToken: window.judgemeApiPublicToken,
  };

  const state = {
    page: 1,
    isLoading: false,
    filterRating: "",
    perPage: 10,
    search: "",
  };

  // Get URL parameters
  function getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      filterRating: urlParams.get("filter_rating") || "",
      perPage: parseInt(urlParams.get("per_page")) || 10,
      page: parseInt(urlParams.get("page")) || 1,
      search: urlParams.get("search") || "",
    };
  }

  // Initialize state from URL parameters
  function initializeStateFromUrl() {
    const params = getUrlParams();
    state.filterRating = params.filterRating;
    state.perPage = params.perPage;
    state.page = params.page;
    state.search = params.search;

    // Update UI to reflect URL parameters
    updateDisplayCountButtons();
    updateSearchInput();
    // Note: updateFilterButtons() is called after rating breakdown is created
  }

  // Update display count buttons based on current perPage
  function updateDisplayCountButtons() {
    const countButtons = document.querySelectorAll(".count-btn");
    countButtons.forEach((btn) => {
      const count = parseInt(btn.dataset.count);
      if (count === state.perPage) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    });
  }

  // Update filter buttons based on current filterRating
  function updateFilterButtons() {
    // Update rating breakdown items to show active state
    const ratingItems = document.querySelectorAll(".rating-breakdown-item");

    ratingItems.forEach((item) => {
      const rating = item.dataset.rating;

      if (rating === state.filterRating) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  // Update search input based on current search state
  function updateSearchInput() {
    const searchInput = document.getElementById("reviews-search");
    if (searchInput) {
      searchInput.value = state.search;
    }
  }

  // Update pagination UI
  function updatePagination() {
    const paginationContainer = document.getElementById("reviews-pagination");
    const prevBtn = document.getElementById("prev-btn");
    const nextBtn = document.getElementById("next-btn");

    if (!paginationContainer || !prevBtn || !nextBtn) return;

    // Show pagination if we have reviews
    const reviewsContainer = document.getElementById("judgeme_all_reviews");
    const currentReviews = reviewsContainer
      ? reviewsContainer.querySelectorAll(".jdgm-rev").length
      : 0;

    if (currentReviews > 0) {
      paginationContainer.style.display = "flex";
    } else {
      paginationContainer.style.display = "none";
      return;
    }

    // Update previous button - enable if not on first page
    if (state.page > 1) {
      prevBtn.disabled = false;
      prevBtn.classList.remove("disabled");
    } else {
      prevBtn.disabled = true;
      prevBtn.classList.add("disabled");
    }

    // Update next button - enable if there might be more pages
    // We can't know for sure, so enable if we have a full page of results
    if (currentReviews >= state.perPage) {
      // Full page - there might be more
      nextBtn.disabled = false;
      nextBtn.classList.remove("disabled");
    } else {
      // Less than full page - this is likely the last page
      nextBtn.disabled = true;
      nextBtn.classList.add("disabled");
    }
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // ===== JUDGE.ME REVIEW REORGANIZATION FUNCTIONS =====
  // Adapted from script.product_detail.js

  function parseAndReorganizeWidget(htmlWidget) {
    const container = document.getElementById("judgeme_all_reviews");

    // Create temporary container to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlWidget;

    // Find all review elements
    const reviews = tempDiv.querySelectorAll(".jdgm-rev");

    if (reviews.length === 0) {
      displayNoReviews();
      return;
    }

    // Clear container for each page load (pagination behavior)
    container.innerHTML = "";

    // Process each review
    reviews.forEach((review) => {
      const reorganizedReview = reorganizeReviewStructure(review);
      container.appendChild(reorganizedReview);
    });

    // Hide load more button if we have fewer than 5 reviews (likely all reviews)
    if (reviews.length < 5) {
      hideLoadMoreButton();
    }
  }

  function parseHistogramData(htmlWidget) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlWidget;

    // Find histogram rows
    const histogramRows = tempDiv.querySelectorAll(".jdgm-histogram__row");
    const histogramData = [];

    histogramRows.forEach((row) => {
      const rating = row.getAttribute("data-rating");
      const frequency = row.getAttribute("data-frequency");
      const percentage = row.getAttribute("data-percentage");

      if (rating && frequency && percentage) {
        histogramData.push({
          rating: parseInt(rating),
          frequency: parseInt(frequency),
          percentage: parseInt(percentage),
        });
      }
    });

    return histogramData;
  }

  function createRatingBreakdown(histogramData) {
    const breakdownContainer = document.createElement("div");
    breakdownContainer.className = "rating-breakdown";

    // Sort by rating (5 to 1)
    const sortedData = histogramData.sort((a, b) => b.rating - a.rating);

    sortedData.forEach((data) => {
      const breakdownItem = document.createElement("div");
      breakdownItem.className = "rating-breakdown-item";
      breakdownItem.dataset.rating = data.rating;

      breakdownItem.innerHTML = `
        <div class="rating-label">
          <div class="rating-number">
            <svg class="star-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#666666"/>
            </svg>
            <span class="number">${data.rating}</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" style="width: ${data.percentage}%"></div>
          </div>
        </div>
        <div class="count">${data.frequency}件</div>
      `;

      // Add click event listener for filtering
      breakdownItem.addEventListener("click", function () {
        const rating = this.dataset.rating;
        if (rating === state.filterRating) {
          // If already filtered by this rating, clear filter
          state.filterRating = "";
        } else {
          // Filter by this rating
          state.filterRating = rating;
        }
        state.search = "";
        state.page = 1; // Reset to first page
        updateFilterButtons();
        updateUrl();
        loadAllReviews(true);
      });

      breakdownContainer.appendChild(breakdownItem);
    });

    return breakdownContainer;
  }

  function updateRatingSummary(htmlWidget) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlWidget;

    // Find summary data
    const summaryElement = tempDiv.querySelector(".jdgm-all-reviews__summary");
    if (!summaryElement) return;

    const averageRating = tempDiv
      .querySelector(".jdgm-all-reviews__header")
      ?.getAttribute("data-average-rating");
    const totalReviews = tempDiv
      .querySelector(".jdgm-all-reviews__header")
      ?.getAttribute("data-number-of-reviews");

    // Update rating summary display
    const ratingSummary = document.querySelector(".rating-summary");
    if (ratingSummary && averageRating && totalReviews) {
      const averageElement = ratingSummary.querySelector(".average");
      const totalElement = ratingSummary.querySelector(".total");
      const starsElement = ratingSummary.querySelector(".stars");

      if (averageElement) {
        averageElement.textContent = parseFloat(averageRating).toFixed(2);
      }

      if (totalElement) {
        totalElement.textContent = `(${totalReviews}件)`;
      }

      // Update stars based on actual rating
      if (starsElement) {
        const rating = parseFloat(averageRating);
        const fullStars = Math.floor(rating);

        let starsHTML = "";

        // Create full stars
        for (let i = 0; i < fullStars; i++) {
          starsHTML += '<span class="jdgm-star jdgm--on"></span>';
        }

        // Create empty stars to make 5 stars
        const emptyStars = 5 - fullStars;
        for (let i = 0; i < emptyStars; i++) {
          starsHTML += '<span class="jdgm-star jdgm--off"></span>';
        }

        starsElement.innerHTML = starsHTML;
      }
    }

    // Parse and display histogram data
    const histogramData = parseHistogramData(htmlWidget);
    if (histogramData.length > 0) {
      const existingBreakdown = document.querySelector(".rating-breakdown");
      if (existingBreakdown) {
        existingBreakdown.remove();
      }

      const ratingBreakdown = createRatingBreakdown(histogramData);
      // Append to reviews header instead of rating summary
      const reviewsHeader = document.querySelector(".reviews-header");
      if (reviewsHeader) {
        reviewsHeader.appendChild(ratingBreakdown);

        // Update filter buttons after rating breakdown is created
        updateFilterButtons();
      }
    }
  }

  // Extract images from [IMG] tags in review body
  function extractImagesFromBody(bodyText) {
    if (!bodyText) return [];

    const imageRegex = /\[IMG\](.*?)\[\/IMG\]/g;
    const extractedImages = [];
    let match;

    while ((match = imageRegex.exec(bodyText)) !== null) {
      extractedImages.push(match[1].trim());
    }

    return extractedImages;
  }

  // Clean review body by removing [IMG] tags
  function cleanReviewBody(bodyText) {
    if (!bodyText) return "";

    return bodyText
      .replace(/\[IMG\](.*?)\[\/IMG\]/g, "") // Remove [IMG] tags
      .replace(/\n{3,}/g, "\n\n") // Clean up extra newlines
      .trim(); // Remove leading/trailing whitespace
  }

  function reorganizeReviewStructure(originalReview) {
    // Create main container (Frame 315)
    const reviewDiv = document.createElement("div");
    reviewDiv.className = "jdgm-rev-custom";

    // Extract elements from original review
    const author = originalReview.querySelector(".jdgm-rev__author");
    const rating = originalReview.querySelector(".jdgm-rev__rating");
    const title = originalReview.querySelector(".jdgm-rev__title");
    const body = originalReview.querySelector(".jdgm-rev__body");
    const timestamp = originalReview.querySelector(".jdgm-rev__timestamp");
    const productLink = originalReview.querySelector(".jdgm-rev__prod-link");
    const pics = originalReview.querySelector(".jdgm-rev__pics");

    // Extract images from body [IMG] tags and clean the body
    let bodyText = "";
    let extractedImages = [];
    if (body && body.textContent) {
      bodyText = body.textContent;
      extractedImages = extractImagesFromBody(bodyText);
      bodyText = cleanReviewBody(bodyText);
    }

    // Frame 1261153458: Author + Product info row (Row 1)
    const authorProductFrame = document.createElement("div");
    authorProductFrame.className = "jdgm-rev__author-product-frame";

    // Frame 200: Author name
    const authorFrame = document.createElement("div");
    authorFrame.className = "jdgm-rev__author-frame";
    if (author) {
      const authorClone = author.cloneNode(true);
      authorFrame.appendChild(authorClone);
    }

    // Product info
    const productFrame = document.createElement("div");
    productFrame.className = "jdgm-rev__product-frame";
    if (productLink) {
      const productClone = productLink.cloneNode(true);
      productClone.textContent = `(${productClone.textContent.trim()})`;
      productFrame.appendChild(productClone);
    }

    authorProductFrame.appendChild(authorFrame);
    authorProductFrame.appendChild(productFrame);

    // Frame 1795: Content wrapper (Row 2)
    const contentFrame = document.createElement("div");
    contentFrame.className = "jdgm-rev__content-frame";

    // Frame 208: Rating + Title row (same line)
    const ratingTitleFrame = document.createElement("div");
    ratingTitleFrame.className = "jdgm-rev__rating-title-frame";

    // Frame 207: Rating stars
    const ratingFrame = document.createElement("div");
    ratingFrame.className = "jdgm-rev__rating-frame";

    if (rating) {
      const ratingClone = rating.cloneNode(true);
      ratingFrame.appendChild(ratingClone);
    }

    // Add rating frame first
    ratingTitleFrame.appendChild(ratingFrame);

    // Title (same line as rating) - use existing title or first sentence
    if (title && title.textContent.trim()) {
      const titleElement = document.createElement("span");
      titleElement.className = "jdgm-rev__title";
      titleElement.textContent = title.textContent.trim();
      ratingTitleFrame.appendChild(titleElement);
    } else if (bodyText && bodyText.trim()) {
      const firstSentence =
        bodyText.split(".")[0] + (bodyText.includes(".") ? "." : "");
      const titleElement = document.createElement("span");
      titleElement.className = "jdgm-rev__title";
      titleElement.textContent = firstSentence;
      ratingTitleFrame.appendChild(titleElement);
    }

    contentFrame.appendChild(ratingTitleFrame);

    // Review content (separate line) - use cleaned body text
    if (bodyText && bodyText.trim()) {
      const bodyElement = document.createElement("div");
      bodyElement.className = "jdgm-rev__body";
      bodyElement.textContent = bodyText;
      contentFrame.appendChild(bodyElement);
    }

    // Build main structure
    reviewDiv.appendChild(authorProductFrame);
    reviewDiv.appendChild(contentFrame);

    // Frame 1261153462: Image gallery (if exists) - AFTER content
    // Merge images from both sources: original pics and extracted images from body
    const allImages = [];

    // Collect images from original pics container
    if (pics && pics.children.length > 0) {
      Array.from(pics.children).forEach((img) => {
        let imageUrl = "";

        if (img.tagName === "A") {
          // If it's a link, get the img inside
          const innerImg = img.querySelector("img");
          if (innerImg) {
            imageUrl = innerImg.getAttribute("data-src") || innerImg.src;
          }
        } else if (img.tagName === "IMG") {
          // If it's directly an img element
          imageUrl = img.getAttribute("data-src") || img.src;
        }

        if (imageUrl) {
          allImages.push(imageUrl);
        }
      });
    }

    // Add extracted images from body [IMG] tags
    if (extractedImages.length > 0) {
      allImages.push(...extractedImages);
    }

    // Create image gallery if we have any images
    if (allImages.length > 0) {
      const imageGalleryFrame = document.createElement("div");
      imageGalleryFrame.className = "jdgm-rev__image-gallery";

      allImages.forEach((imageUrl) => {
        const imageFrame = document.createElement("div");
        imageFrame.className = "jdgm-rev__image-frame";

        const newImg = document.createElement("img");
        newImg.src = imageUrl;
        newImg.alt = "Review image";
        newImg.className = "jdgm-rev__pic-img";

        // Add error handling for broken images
        newImg.onerror = function () {
          this.style.display = "none";
        };

        imageFrame.appendChild(newImg);
        imageGalleryFrame.appendChild(imageFrame);
      });

      reviewDiv.appendChild(imageGalleryFrame);
    }

    // Timestamp (separate element at bottom)
    if (timestamp) {
      const timestampClone = document.createElement("div");
      timestampClone.className = "jdgm-rev__timestamp-frame";
      timestampClone.textContent = formatTimestamp(
        timestamp.getAttribute("data-content")
      );
      reviewDiv.appendChild(timestampClone);
    }

    return reviewDiv;
  }

  function formatTimestamp(timestampString) {
    if (!timestampString) return "";

    try {
      // Debug log to see actual data

      // Normalize to ISO 8601: YYYY-MM-DDTHH:mm:ssZ
      let isoString = timestampString.trim();

      // Handle different formats and normalize to ISO 8601
      if (isoString.includes(" UTC")) {
        // Format: "2024-01-15 10:30:00 UTC" -> "2024-01-15T10:30:00Z"
        isoString = isoString.replace(" UTC", "Z").replace(" ", "T");
      } else if (isoString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
        // Format: "2024-01-15 10:30:00" -> "2024-01-15T10:30:00Z"
        isoString = isoString.replace(" ", "T") + "Z";
      } else if (isoString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
        // Format: "2024-01-15T10:30:00" -> "2024-01-15T10:30:00Z"
        isoString = isoString + "Z";
      } else if (isoString.match(/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/)) {
        // Format: "2024/01/15 10:30:00" -> "2024-01-15T10:30:00Z"
        isoString = isoString.replace(/\//g, "-").replace(" ", "T") + "Z";
      } else if (isoString.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
        // Format: "2024/01/15" -> "2024-01-15T00:00:00Z"
        isoString = isoString.replace(/\//g, "-") + "T00:00:00Z";
      } else if (isoString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Format: "2024-01-15" -> "2024-01-15T00:00:00Z"
        isoString = isoString + "T00:00:00Z";
      } else if (isoString.match(/^\d{10}$/)) {
        // Unix timestamp (seconds) -> ISO 8601
        const date = new Date(parseInt(isoString) * 1000);
        isoString = date.toISOString();
      } else if (isoString.match(/^\d{13}$/)) {
        // Unix timestamp (milliseconds) -> ISO 8601
        const date = new Date(parseInt(isoString));
        isoString = date.toISOString();
      } else {
        // Fallback: add UTC suffix and normalize
        isoString = isoString + " UTC";
        isoString = isoString.replace(" UTC", "Z").replace(" ", "T");
      }

      // Parse with normalized ISO 8601
      const date = new Date(isoString);

      if (isNaN(date.getTime())) {
        console.warn("Failed to parse normalized ISO string:", isoString);
        return "日付不明";
      }

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      // Check if date components are valid
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        console.warn("Date components are NaN:", { year, month, day });
        return "日付不明";
      }

      const result = `${year}年${month}月${day}日`;
      return result;
    } catch (error) {
      console.warn(
        "Error in formatTimestamp:",
        error,
        "for input:",
        timestampString
      );
      return "日付不明";
    }
  }

  function displayNoReviews() {
    const container = document.getElementById("judgeme_all_reviews");
    if (container) {
      container.innerHTML =
        '<div class="no-reviews">レビューがありません</div>';
    }
    // Hide load more button when no reviews
    hideLoadMoreButton();

    // Ensure reviews-header is still visible even when no reviews
    const reviewsHeader = document.querySelector(".reviews-header");
    if (reviewsHeader) {
      reviewsHeader.style.display = "block";
    }
  }

  function displayError() {
    const container = document.getElementById("judgeme_all_reviews");
    if (container) {
      container.innerHTML =
        '<div class="reviews-error">レビューの読み込み中にエラーが発生しました</div>';
    }
    // Hide load more button when error occurs
    hideLoadMoreButton();
  }

  function hideLoadMoreButton() {
    const loadMoreContainer = document.querySelector(".reviews-load-more");
    if (loadMoreContainer) {
      loadMoreContainer.style.display = "none";
    }
  }

  // Load rating breakdown when filtering but no reviews found
  async function loadRatingBreakdownForFilter() {
    try {
      // Load all reviews without filter to get rating breakdown
      const url = `https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=${encodeURIComponent(
        CONFIG.shopDomain
      )}&api_token=${encodeURIComponent(CONFIG.apiToken)}&page=1&per_page=1`;
      const res = await fetch(url);
      if (!res.ok) return;

      const data = await res.json();
      if (data && data.all_reviews_header) {
        updateRatingSummary(data.all_reviews_header);
      }
    } catch (error) {
      // Silently fail - rating breakdown is not critical
    }
  }

  // ===== END JUDGE.ME REVIEW REORGANIZATION FUNCTIONS =====

  // Load more reviews function (similar to product_detail.js)
  window.loadMoreReviewsInAllReviews =
    async function loadMoreReviewsInAllReviews() {
      if (state.isLoading) return;

      try {
        // Calculate next page based on current reviews
        const currentReviews = document.querySelectorAll(".jdgm-rev-custom");
        const nextPage = state.page + 1;

        // API endpoint for next page
        const url = `https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=${encodeURIComponent(
          CONFIG.shopDomain
        )}&api_token=${encodeURIComponent(
          CONFIG.apiToken
        )}&page=${nextPage}&filter_rating=${state.filterRating}&per_page=${
          state.perPage
        }&search=${state.search}`;

        const response = await fetch(url);
        if (!response.ok)
          throw new Error("さらにレビューを取得できませんでした");
        const data = await response.json();

        if (data && data.all_reviews) {
          // Parse HTML widget and append new reviews
          window.appendMoreReviews(data.all_reviews);

          // Update state to reflect the new page
          state.page = nextPage;
          updateUrl();
          updatePagination();
        } else {
          // Hide load more button if no more reviews
          hideLoadMoreButton();
        }
      } catch (error) {
        hideLoadMoreButton();
      }
    };

  window.appendMoreReviews = function appendMoreReviews(htmlWidget) {
    const container = document.getElementById("judgeme_all_reviews");
    if (!container) return;

    // Create temporary container to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlWidget;

    // Find all review elements
    const reviews = tempDiv.querySelectorAll(".jdgm-rev");

    if (reviews.length === 0) {
      hideLoadMoreButton();
      return;
    }

    // Process each new review and append to existing container
    reviews.forEach((review) => {
      const reorganizedReview = reorganizeReviewStructure(review);
      container.appendChild(reorganizedReview);
    });

    // Hide load more button if we got fewer reviews than expected (last page)
    if (reviews.length < state.perPage) {
      hideLoadMoreButton();
    }
  };

  async function loadAllReviews(initial = false) {
    if (state.isLoading) return;
    state.isLoading = true;
    try {
      const container = document.getElementById("judgeme_all_reviews");
      if (!container) return;

      const url = `https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=${encodeURIComponent(
        CONFIG.shopDomain
      )}&api_token=${encodeURIComponent(CONFIG.apiToken)}&page=${
        state.page
      }&filter_rating=${state.filterRating}&per_page=${state.perPage}&search=${
        state.search
      }`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("さらにレビューを取得できませんでした");
      const data = await res.json();

      // Handle the new JSON response format
      if (data && data.all_reviews) {
        // Create temporary container to parse HTML for pagination calculation
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data.all_reviews;

        // Use reorganization function to parse the HTML from all_reviews
        parseAndReorganizeWidget(data.all_reviews);

        // Count actual review elements in response
        const reviewsCount = tempDiv.querySelectorAll(".jdgm-rev").length;

        // Update rating summary and histogram on initial load only
        if (initial && data.all_reviews_header) {
          updateRatingSummary(data.all_reviews_header);
        } else if (initial && !data.all_reviews_header) {
          // If no header data but initial load, ensure reviews-header is visible
          const reviewsHeader = document.querySelector(".reviews-header");
          if (reviewsHeader) {
            reviewsHeader.style.display = "block";
          }
        }

        // Update pagination UI after calculating total pages
        updatePagination();
      } else {
        displayNoReviews();
        updatePagination();

        // If we have filter rating but no reviews, still show rating breakdown for navigation
        if (state.filterRating && initial) {
          // Try to load rating breakdown from a general API call
          loadRatingBreakdownForFilter();
        }
      }

      // Don't increment page here - it's managed by pagination buttons
    } catch (e) {
      displayError();
    } finally {
      state.isLoading = false;
    }
  }

  // Update URL with current parameters
  function updateUrl() {
    const url = new URL(window.location);
    url.searchParams.set("per_page", state.perPage);
    if (state.filterRating) {
      url.searchParams.set("filter_rating", state.filterRating);
    } else {
      url.searchParams.delete("filter_rating");
    }
    if (state.page > 1) {
      url.searchParams.set("page", state.page);
    } else {
      url.searchParams.delete("page");
    }
    if (state.search) {
      url.searchParams.set("search", state.search);
    } else {
      url.searchParams.delete("search");
    }
    window.history.replaceState({}, "", url);
  }

  onReady(function () {
    if (!CONFIG.shopDomain || !CONFIG.apiToken) return;

    // Initialize state from URL parameters
    initializeStateFromUrl();

    // Load reviews with current state
    loadAllReviews(true);

    // Add event listeners for display count buttons
    const countButtons = document.querySelectorAll(".count-btn");
    countButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const newPerPage = parseInt(this.dataset.count);
        if (newPerPage !== state.perPage) {
          state.perPage = newPerPage;
          state.page = 1; // Reset to first page
          updateDisplayCountButtons();
          updateUrl();
          loadAllReviews(true);
        }
      });
    });

    // Add event listener for search input
    const searchInput = document.getElementById("reviews-search");
    if (searchInput) {
      let searchTimeout;
      searchInput.addEventListener("input", function () {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          const newSearch = this.value.trim();
          if (newSearch !== state.search) {
            state.search = newSearch;
            state.page = 1; // Reset to first page
            updateUrl();
            loadAllReviews(true);
          }
        }, 500); // Debounce search by 500ms
      });
    }

    // Add event listeners for pagination buttons
    const prevBtn = document.getElementById("prev-btn");
    const nextBtn = document.getElementById("next-btn");

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        if (state.page > 1) {
          state.page = state.page - 1;
          updateUrl();
          loadAllReviews(true);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        // Always allow next if button is enabled
        if (!nextBtn.disabled) {
          state.page = state.page + 1;
          updateUrl();
          loadAllReviews(true);
        }
      });
    }

    const btn = document.getElementById("btnLoadMoreAllReviews");
    if (btn)
      btn.addEventListener("click", function () {
        loadMoreReviewsInAllReviews();
      });
  });
})();
